import { FINANCE, LEASE } from '@makemydeal/dr-platform-types';

/**
 * Makes specified properties of a type optional
 * @template T - The original type
 * @template K - The keys to make optional (must be keys of T)
 */
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export const OFFER_TYPE_MODES = { FINANCE, LEASE } as const;

export type OfferTypeMode = (typeof OFFER_TYPE_MODES)[keyof typeof OFFER_TYPE_MODES];
